export const ASSET_CLASS_OPTIONS = [
  { value: 'CRYPTO', label: '數字貨幣' },
  { value: 'FIAT_BANK', label: '法幣銀行卡' },
  { value: 'FIAT_EWALLET', label: '法幣電子支付' },
  { value: 'FIAT_WALLET', label: '法幣三方錢包' },
];

export const PAY_METHOD_KIND_OPTIONS = [
  { value: 'ON_CHAIN', label: '鏈上資產' },
  { value: 'BANK_CARD', label: '銀行卡' },
  { value: 'UNION_PAY', label: '銀聯卡' },
  { value: 'EWALLET', label: '電子錢包' },
  { value: 'THIRD_PARTY_WALLET', label: '三方代付錢包' },
];

export const DEFAULT_COIN_PAY_TYPE_FORM = {
  code: '',
  name: '',
  currency: '',
  protocol: '',
  assetClass: 'CRYPTO',
  payMethodKind: 'ON_CHAIN',
  image: '',
  sort: '0',
  isThirdPartyWallet: false,
  supportCny: false,
  supportUsd: false,
  customRate: true,
  customDepositRate: '1',
  customWithdrawRate: '1',
};

export function buildCoinPayTypePageParams(pageNo, filters) {
  const params = {
    pageNo,
    pageSize: 15,
  };
  if (filters.code?.trim()) {
    params.code = filters.code.trim();
  }
  if (filters.currency?.trim()) {
    params.currency = filters.currency.trim();
  }
  return params;
}

export function rowToForm(row) {
  if (!row) {
    return { ...DEFAULT_COIN_PAY_TYPE_FORM };
  }
  return {
    code: row.code ?? '',
    name: row.name ?? '',
    currency: row.currency ?? '',
    protocol: row.protocol ?? '',
    assetClass: row.assetClass ?? 'CRYPTO',
    payMethodKind: row.payMethodKind ?? 'ON_CHAIN',
    image: row.image ?? '',
    sort: row.sort != null ? String(row.sort) : '0',
    isThirdPartyWallet: Boolean(row.isThirdPartyWallet),
    supportCny: Boolean(row.supportCny),
    supportUsd: Boolean(row.supportUsd),
    customRate: row.customRate !== false,
    customDepositRate: row.customDepositRate != null ? String(row.customDepositRate) : '1',
    customWithdrawRate: row.customWithdrawRate != null ? String(row.customWithdrawRate) : '1',
  };
}

function parseOptionalNumber(value, fallback = null) {
  if (value === '' || value == null) {
    return fallback;
  }
  const num = Number(value);
  return Number.isNaN(num) ? fallback : num;
}

export function formToPayload(form, editingId) {
  const payload = {
    code: form.code?.trim(),
    name: form.name?.trim(),
    currency: form.currency?.trim(),
    protocol: form.protocol?.trim() || null,
    assetClass: form.assetClass || null,
    payMethodKind: form.payMethodKind || null,
    image: form.image?.trim() || null,
    sort: parseOptionalNumber(form.sort, 0),
    isThirdPartyWallet: Boolean(form.isThirdPartyWallet),
    supportCny: Boolean(form.supportCny),
    supportUsd: Boolean(form.supportUsd),
    customRate: Boolean(form.customRate),
    customDepositRate: parseOptionalNumber(form.customDepositRate, 1),
    customWithdrawRate: parseOptionalNumber(form.customWithdrawRate, 1),
  };
  if (editingId != null) {
    payload.id = editingId;
  }
  return payload;
}
